import moment from 'moment/moment'

// eslint-disable-next-line no-unused-vars
const ptBrLocale = require('moment/locale/pt-br')

export default function getMonth(date) {
  if (!date) {
    return null
  }
  return moment(date)
    .locale('pt-br')
    .format('MMMM')
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/getMonth.js